<template>
  <!-- 保单详情 -->
  <dialogWrap
    v-model="isShow"
    title="风险跟进"
    :width="'528px'"
    :before-close="closeDialog"
    :close-on-click-modal="true"
  >
    <el-form  ref="followRef" label-width="80px" :model="followFrom" :rules="followRules">
      <el-form-item prop="content" label="跟进结果">
        <el-input  show-word-limit maxlength="200" type="textarea" v-model="followFrom.content"></el-input>
      </el-form-item>
      <el-form-item label="图片上传">
          <div class="upload">
            <UploadCommon
              :limit="4"
              :fileList.sync="followFrom.imgList"
              :isAlone="false"
              :sizeType="4"
              commonUpload
              group="order"
              code="order_risk_control_pic"
            >
            </UploadCommon>
          </div>
        </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="confirm">确 定</el-button>
    </div>

  </dialogWrap>
</template>
<script>
import { addFollow } from '@/api/domain/orders'

export default {
  data() {
    return {
      isShow: false,
      submitLoading: false,
      followFrom: {
        content: '',
        imgList: [],
      },
      followRules: {
        content: [{ required: true, message: '请填写跟进结果', trigger: 'blur' }],
      },
    }
  },
  props: {
    id: {
      type: [Number, String],
      default: '',
    },
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    showDialog() {
      this.followFrom.imgList = []
      this.submitLoading = false
      this.isShow = true
    },
    closeDialog() {
      this.isShow = false
      this.followFrom.imgList = []
      this.content = ''
      this.$refs.followRef.resetFields()
    },
    confirm() {
      if (this.submitLoading) return
      this.$refs.followRef.validate((valid) => {
        console.log(this.id)
        if (!valid || !this.id) return
        this.submitLoading = true
        const { content, imgList } = this.followFrom
        addFollow({
          bizId: this.id,
          describe: content,
          photo: imgList.length > 0 ? this.getUoloadCommonFileData(imgList) : JSON.stringify([]),
          sourceType: 2, // 跟进类型 1.逾期 2.风控
        }).then((res) => {
          if (res.code !== 1) {
            this.submitLoading = false
            return
          }
          this.$message.success('跟进成功')
          this.closeDialog()
          this.$emit('followSuccess')
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
